import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'flex-start',

      '&$wideTitle $title': {
        width: 150,
      },
    },
    wideTitle: {},

    title: {
      width: 115,
      flexShrink: 0,

      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.primary,
      marginRight: theme.spacing(1),
    },
    value: {
      overflow: 'hidden',

      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.mediumGray,
    },
  }),
  { name: 'Annotation' }
);
